"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolatilitySurface = exports.getSurfaceRange = exports.getTickersByExpiry = exports.getAllExpirations = void 0;
const calculationsCore_1 = require("../calculationsCore");
const getPt = (x1, y1, x2, y2, x) => {
    return y1 + ((x - x1) * (y2 - y1)) / (x2 - x1);
};
const getAllExpirations = (tickers) => {
    const set = new Set();
    for (const ticker of tickers) {
        const exp = (0, calculationsCore_1.getExpiryTimestampFromInstrumentString)(ticker.instrument_name);
        set.add(exp);
    }
    return Array.from(set).sort((a, b) => a - b);
};
exports.getAllExpirations = getAllExpirations;
const getTickersByExpiry = (expiry, tickers) => {
    const res = [];
    for (const ticker of tickers) {
        const exp = (0, calculationsCore_1.getExpiryTimestampFromInstrumentString)(ticker.instrument_name);
        if (exp === expiry) {
            res.push(ticker);
        }
    }
    return res.sort((a, b) => (0, calculationsCore_1.getOptionInstrumentStrike)(a.instrument_name) -
        (0, calculationsCore_1.getOptionInstrumentStrike)(b.instrument_name));
};
exports.getTickersByExpiry = getTickersByExpiry;
const getUninterpoletedVolSurface = (tickers) => {
    const expirations = (0, exports.getAllExpirations)(tickers);
    const domain = [];
    for (let i = 0; i < 100; i++) {
        domain.push(i);
    }
    const z = [];
    for (const exp of expirations) {
        const currentExpiryTickers = (0, exports.getTickersByExpiry)(exp, tickers);
        let y = new Array(100).fill(0);
        for (const ticker of currentExpiryTickers) {
            const deltaIndex = Math.floor(ticker.greeks.delta * 100);
            if (deltaIndex === 100) {
                y[99] = ticker.mark_iv;
            }
            else {
                y[deltaIndex] = ticker.mark_iv;
            }
        }
        z.push(y);
    }
    return { z, x: domain, y: expirations };
};
// find index from start of a number [1,1,1,2] -> 3
const getIndexOfConsecutiveNumber = (arr, num) => {
    let counter = 0;
    while (arr[counter] === num) {
        counter++;
    }
    return counter;
};
/**
 * Point to point interpolation. Interpolates as a straight line
 * @param index
 * @param arr
 * @returns
 */
const p2p = (index, arr) => {
    let firstIndex = 0;
    let lastIndex = 0;
    for (let i = index; arr[i] === 0; i++) {
        lastIndex = i + 1;
    }
    for (let i = index; arr[i] === 0; i--) {
        firstIndex = i - 1;
    }
    const res = getPt(firstIndex, arr[firstIndex], lastIndex, arr[lastIndex], index);
    return res;
};
const getInterpolatedLine = (arr) => {
    const startIndex = getIndexOfConsecutiveNumber(arr, 0);
    const endIndex = arr.length - getIndexOfConsecutiveNumber([...arr].reverse(), 0);
    const cutArray = arr.slice(startIndex, endIndex);
    let interpolatorPts = [];
    for (let i = 0; i < cutArray.length; i++) {
        if (cutArray[i] !== 0) {
            interpolatorPts.push([i, cutArray[i]]);
        }
    }
    const res = cutArray.map((p, i) => {
        return p === 0 ? p2p(i, cutArray) : p;
    });
    const firstSegment = new Array(startIndex).fill(arr[startIndex]);
    const lastSegment = new Array(arr.length - endIndex).fill(arr[endIndex - 1]);
    const final = [...firstSegment, ...res, ...lastSegment];
    return final;
};
const interpolateSurface = ({ x, y, z }) => {
    // fill in missing strikes
    const newZ = [];
    for (let i = 0; i < y.length; i++) {
        const curInterpolated = getInterpolatedLine([...z[i]]);
        newZ.push(curInterpolated);
    }
    return { x, y, z: newZ };
};
const getSurfaceRange = (grid, x1, x2, y1, y2) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = Number.MIN_SAFE_INTEGER;
    for (let i = y1; i < y2; i++) {
        for (let j = x1; j <= x2; j++) {
            min = Math.min(min, grid[i][j]);
            max = Math.max(max, grid[i][j]);
        }
    }
    return { min, max };
};
exports.getSurfaceRange = getSurfaceRange;
const getVolatilitySurface = (tickers) => {
    const surface = getUninterpoletedVolSurface(tickers);
    const interpolatedSurface = interpolateSurface(surface);
    return interpolatedSurface;
};
exports.getVolatilitySurface = getVolatilitySurface;
